<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">审批</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>OTC出金审核</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content">
      <div class="actions-bar">
        <div>
          <el-select v-model="statue" placeholder="请选择状态">
            <el-option v-for="item in status" :key="item.key" :label="item.label" :value="item.key"></el-option>
          </el-select>
          <el-select v-model="tenantId" placeholder="租户选择" clearable>
            <el-option v-for="item in tenantList" :key="item.id
            " :label="item.tenantName" :value="item.id
            ">
            </el-option>
          </el-select>
          <el-input placeholder="请输入用户ID" clearable v-model="userId">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <el-date-picker v-model="times" type="daterange" format="yyyy 年 MM 月 dd 日" range-separator="至"
            start-placeholder="开始" end-placeholder="结束"></el-date-picker>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button :type="otcSwitch ? 'primary' : 'info'" @click="changeSwitch">{{ otcSwitch ? "OTC卖出关闭" : "OTC卖出开启"
            }}</el-button>
        </div>

      </div>
      <audit-list @refresh="refreshList($event)"></audit-list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import AuditList from './components/list';
import { PAGINATION } from './constants';
import api from './api';
import { tenantInfo } from '@/common/publicApi'
export default {
  data() {
    return {
      userId: null,
      times: [],
      tenantId: '',
      tenantList: [],
      status: [
        { label: '全部', key: '', },
        { label: '审核中', key: -2, },
        { label: '进行中', key: -1, },
        { label: '成功', key: 1, },
        { label: '失败', key: 0, }
      ],
      statue: '',
      otcSwitch: false
    };
  },
  components: {
    AuditList
  },
  computed: {
    ...mapState('otcAudit', ['pagination']),
    startDate() {
      let time = new Date(new Date(this.times[0]).setHours(0, 0, 0, 0)).getTime();
      return this.times && this.times.length > 0 ? time : '';
    },
    endDate() {
      const time = new Date(new Date(this.times[1]).setHours(23, 59, 59, 999)).getTime()
      return this.times && this.times.length > 0 ? time : '';
    },

  },
  mounted() {
    tenantInfo().then(res => {
      if (res.code == 0) {
        this.tenantList = res.data;
      }
    })
    this.handleSearch();
    this.getSwitchStatueFn()
  },
  methods: {
    ...mapActions('otcAudit', ['list']),
    getSwitchStatueFn() {
      api.getSwitchStatue().then(res => {
        if (res.code == 0) {
          this.otcSwitch = res.data
        }
      })
    },
    changeSwitch() {
      let text = this.otcSwitch ? '关闭' : '开启'
      this.$confirm(`确认将OTC卖出${text}吗？`, '提示', {
        type: 'warning'
      }).then(() => {
        api.setSwitchStatue({ otcSwitch: !this.otcSwitch }).then(res => {
          if (res.code == 0) {
            this.getSwitchStatueFn()
          }
        })
      });
    },
    handleSearch() {
      this.list({
        statue: this.statue,
        startTime: this.startDate,
        endTime: this.endDate,
        userId: this.userId,
        tenantId: this.tenantId,
        ...PAGINATION
      });

    },
    refreshList(data = {}) {
      this.list({
        userId: this.userId,
        tenantId: this.tenantId,
        ...this.pagination,
        ...data
      });
    },
  },

};
</script>

<style lang="less" scoped>
.actions-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .el-input,
  .el-select {
    width: 150px;
    margin-right: 10px;
  }

  .el-button {
    margin-left: 10px;
  }

  .el-select {
    margin-right: 10px;
  }
}
</style>
